import {
  convertDateToValidInput,
  defaultDateInputDisplay,
  defaultToastError,
  getAge,
  isNull,
  optionCaraMasuk,
  scrollToTop,
  toDayIndo,
  today,
} from "App/utils/helpers"
import { useContext, useState } from "react"
import { useSelector } from "react-redux"
import { getCaraMasuk, prefixNoRM } from "../../../utils"
import {
  changeAntreanJkn,
  changeLoading,
  changeLoadingJkn,
} from "../../context/actions"
import { RESET_STATE_KUNJUNGAN_RAWAT_JALAN } from "../helpers"
import { TYPE_INSTANCE1, instance2 } from "App/constants"
import { KunjunganRawatJalanCtx } from "../../context/context"
import { useSelectOption } from "App/hooks"
import { LIST_URL_REGISTRASI } from "utils/registrations"
import { dateFormat } from "utils/dates"

function useFormRawatJalan() {
  const { setting } = useSelector((state) => state)
  const { state, dispatch } = useContext(KunjunganRawatJalanCtx)

  const [formData, setFormData] = useState({
    ...RESET_STATE_KUNJUNGAN_RAWAT_JALAN,
    jenis_layanan_id: setting.id_jenis_layanan_rj,
  })

  const [registrationId, setRegistrationId] = useState("")

  const handleClickSelect = (row) => {
    setRegistrationId(null)
    setFormData({
      ...RESET_STATE_KUNJUNGAN_RAWAT_JALAN,
      jenis_layanan_id: setting.id_jenis_layanan_rj,
      patients_id: row?.id,
      norm: row.norm,
      nama_rm: row?.fullname,
      gender: row?.gender === 1 ? "Laki-laki" : "Perempuan",
      gender_print: row.gender,
      umur: getAge(dateFormat({ date: row?.date_ob, formatDate: 'YYYY-MM-DD' })),
      date_ob: row.date_ob,
      date: today(true),
      nohp: row?.mobile_phone_number,
      phone_number: row?.phone_number,
      address_now: row?.address_now,
      penanggung: row?.guarantor_name,
      pekerjaan: row?.pekerjaan_name,
      nik: row?.nik,

      company_id: row?.company_id,
      company_name: row?.company_name,
      insurance_no: row?.insurance_number,
      insurance_id: row?.insurance_id,
      insurance_name: row?.insurance_name,
    })
    dispatch(changeAntreanJkn(null))
  }

  const handleClickSelectBooking = (row) => {
    setRegistrationId(null)
    setFormData({
      ...RESET_STATE_KUNJUNGAN_RAWAT_JALAN,
      jenis_layanan_id: setting.id_jenis_layanan_rj,
      date: today(true),
      booking_id: row?.id,
      doctor_id: row?.doctor_id,
      patients_id: row?.rm_id,
      norm: prefixNoRM(row?.rm_id),
      nama_rm: row?.rm?.fullname,
      gender: row?.rm?.gender === 1 ? "Laki-laki" : "Perempuan",
      umur: getAge(dateFormat({ date: row?.rm?.date_ob, formatDate: 'YYYY-MM-DD' })),
      nohp: row?.rm?.mobile_phone_number,
      phone_number: row?.rm?.phone_number,
      address_now: row?.rm?.address_now,
      penanggung: row?.rm?.guarantor_name,
      pekerjaan: row?.rm?.pekerjaan,
      nik: row?.rm?.nik,

      date_ob: row?.rm?.date_ob,
      gender_print: row?.rm?.gender,

      is_from_booking: true,
      company_id: row?.company_id,
      company_name: row?.company_name,
      insurance_no: row?.insurance_no,
      insurance_id: row?.insurance_id,
      insurance_name: row?.insurance_name,

      initial: row?.initial,
      antrianno: row?.antrianno,

      poli_name: row?.poli_name,
      nama_dokter: row?.nama_dokter,
      day: toDayIndo(row?.day),
      time_start: row?.time_start,
      time_finish: row?.time_finish,
    })
    dispatch(changeAntreanJkn(null))
  }

  const getAntreanJKN = async (id_registrasi) => {
    try {
      const res = await instance2.get(
        "/registration/registration/get-antrian-online-by-registrasi",
        {
          params: {
            id_registrasi: id_registrasi,
          },
        },
      )
      dispatch(changeLoadingJkn(true))
      if (res.status === 200) {
        dispatch(changeAntreanJkn(res.data))
      } else {
        defaultToastError(res.data?.message)
      }
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(changeLoadingJkn(true))
    }
  }

  const layanan = useSelectOption(
    false,
    LIST_URL_REGISTRASI.kunjungan_rawat_jalan.layanan,
    TYPE_INSTANCE1,
  )

  const handleClickUpdate = async (row) => {
    await getAntreanJKN(row.id)

    changeLoading(true)

    const getLayananAntrian = () => {
      if (isNull(row?.layanan_id_antrian)) {
        return {
          layanan_id: "",
          layanan_name: "",
        }
      } else {
        const lyn = layanan.find(
          (x) => x.value === parseInt(row?.layanan_id_antrian),
        )
        return {
          layanan_id: lyn?.value.toString(),
          layanan_name: lyn?.label,
        }
      }
    }

    setRegistrationId(row?.id)
    setFormData({
      ...formData,
      antrianno: row?.antrianno,
      initial: row?.initial,
      date: defaultDateInputDisplay(row?.date, true),
      date_cetak_antrian: row?.date,
      nama_rm: row?.isexternalrm ? row?.rm_name_external : row?.rm_name,
      norm: prefixNoRM(row.patients_id),

      rm_name_external: row.rm_name_external,
      isexternalrm: row.isexternalrm,
      umur: row?.umur,
      nik: row?.nik,
      patients_id: row?.patients_id,
      no_sep: isNull(row?.no_sep) ? "" : row.no_sep,
      jenis_layanan_id: row?.jenis_layanan_id,
      kelaskunjungan_id: row?.kelaskunjungan_id,
      nohp: row?.nohp,

      penanggung: row?.rm_guarantor_name,
      company_id: row?.company_id,
      company_name: row?.company_name,

      insurance_id: row?.insurance_id,
      insurance_name: row?.insurance_name,

      insurance_no: row?.insurance_no,
      norujukan: row?.norujukan,
      nokontrol: row?.nokontrol,
      jenis_kunjungan: row?.jenis_kunjungan,
      tanggal_rujukan: row?.tanggal_rujukan,

      schedule_doctor_id: row?.schedule_doctor_id,
      gender: row?.rm_gender === 1 ? "Laki-Laki" : "Perempuan",
      gender_print: row.rm_gender,
      phone_number: row?.rm_phone_number,
      address_now: row?.rm_address_now,

      sebab_sakit: isNull(formData.sebab_sakit) ? 0 : formData.sebab_sakit,
      // address_now: row?.rm_address_now,
      insurance_type_name: row?.insurance_type_name,
      date_ob: row?.date_ob,
      date_ob_external: row?.date_ob_external,

      doctor_name: row?.doctor_fullname,
      doctor_kodebridge: row?.doctor_kodebridge,
      waktu_estimasi_dilayani: row?.waktu_estimasi_dilayani,

      doctor_id: row?.doctor_id,
      whycancel: row?.whycancel,

      jenis_antrian: isNull(row?.poli_layanan)
        ? "1"
        : row?.poli_layanan.toString(),
      pekerjaan: row?.occupation_name,

      poliklinik_id: row?.doctor_poliklinik_id,

      layanan_ruang_id: isNull(row?.layanan_id)
        ? ""
        : row?.layanan_id.toString(),

      // layanan_id: isNull(row?.layanan_id_antrian)
      //   ? ""
      //   : row?.layanan_id_antrian.toString(),

      layanan_id: getLayananAntrian().layanan_id,
      layanan_name: getLayananAntrian().layanan_name,

      spesialis_name: row?.spesialist_name,
      spesialis_kode: row?.spesialist_kodebridgepoli,

      doctor_schedule_day: row?.doctor_schedule_day,
      doctor_schedule_time_start: row?.doctor_schedule_time_start,
      doctor_schedule_time_finish: row?.doctor_schedule_time_finish,
      doctor_poliklinik_name: row?.doctor_poliklinik_name,
      doctor_poliklinik_remark: row?.doctor_poliklinik_remark,
      poli_name: row.doctor_poliklinik_name,
      status: row.status,

      nama_hak_kelas: row.nama_hak_kelas,
      hak_kelas: row.hak_kelas,
      remark: row.remark,
      cara_masuk: row.cara_masuk,
      cara_masuk_name: getCaraMasuk(row.cara_masuk).cara_masuk_name,
    })

    scrollToTop()
    changeLoading(false)
  }

  const handleClickReset = () => {
    setRegistrationId(null)
    dispatch(changeAntreanJkn(null))
    setFormData({
      ...RESET_STATE_KUNJUNGAN_RAWAT_JALAN,
      jenis_layanan_id: setting.id_jenis_layanan_rj,
    })
  }

  return {
    formData,
    setFormData,
    handleClickSelect,
    handleClickSelectBooking,
    handleClickUpdate,
    registrationId,
    setRegistrationId,
    handleClickReset,
    getAntreanJKN,
  }
}

export default useFormRawatJalan
